module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mall-header'), _vm._v(" "), _c('div', {
    staticClass: "guide-content"
  }), _vm._v(" "), _c('div', {
    staticClass: "invoiceDetails-header"
  }, [_c('nav-Menu'), _vm._v(" "), _c('div', {
    staticClass: "invoice-div-1"
  }, [_c('span', {
    staticClass: "invoice-div-order"
  }, [_vm._v("发票详情")]), _vm._v(" "), _c('span', {
    staticClass: "invoice-div-break",
    on: {
      "click": _vm.openInvoiceList
    }
  }, [_vm._v("返回上一级")]), _vm._v(" "), _c('span', {
    staticClass: "invoice-div-line"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "invoice-info-div"
  }, [_c('span', {
    staticClass: "invoice-info-status"
  }, [_vm._v("发票状态：")]), _vm._v(" "), _c('span', {
    class: _vm.billingStatus == '2' ? 'invoice-info-name' : 'invoice-info-name1'
  }, [_vm._v("   " + _vm._s(_vm.billingName))]), _vm._v(" "), _c('span', {
    staticClass: "invoice-info-type"
  }, [_vm._v("抬头类型：" + _vm._s(_vm.billingTypeName))]), _vm._v(" "), _c('span', {
    staticClass: "invoice-info-company"
  }, [_vm._v("公司名称：" + _vm._s(_vm.invoiceDetails.billingTitle))]), _vm._v(" "), _c('span', {
    staticClass: "invoice-info-taxpayerNo"
  }, [_vm._v("发票税号：" + _vm._s(_vm.invoiceDetails.taxpayerNo))]), _vm._v(" "), _c('span', {
    staticClass: "invoice-info-money"
  }, [_vm._v("开票金额：")]), _vm._v(" "), _c('span', {
    staticClass: "invoice-info-billingAmount"
  }, [_vm._v("￥" + _vm._s(_vm.invoiceDetails.billingAmount))]), _vm._v(" "), _c('span', {
    staticClass: "invoice-info-createTime"
  }, [_vm._v("申请时间：" + _vm._s(_vm.invoiceDetails.createTime))]), _vm._v(" "), (_vm.billingStatus == 2) ? _c('div', {
    staticClass: "invoice-info-img-div"
  }, [_c('img', {
    staticClass: "invoice-info-img",
    attrs: {
      "src": require("../../static/images/fp.png")
    },
    on: {
      "click": _vm.opeFP
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "invoice-info-button",
    on: {
      "click": function($event) {
        return _vm.uplodFiles()
      }
    }
  }, [_vm._v("导出发票")])], 1) : _vm._e(), _vm._v(" "), (_vm.billingStatus == 2) ? _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "-88px",
      "margin-right": "195px"
    }
  }, [_c('span', {
    staticClass: "invoice-info-code"
  }, [_vm._v("发票代码：" + _vm._s(_vm.invoiceDetails.invoiceCode))]), _vm._v(" "), _c('span', {
    staticClass: "invoice-info-num"
  }, [_vm._v("发票号码：" + _vm._s(_vm.invoiceDetails.invoiceNum))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "invoice-shopInfo-font"
  }, [_vm._v("商品信息")]), _vm._v(" "), _vm._l((_vm.invoiceDetails.orderMasters), function(da, index) {
    return _c('div', {
      key: index,
      staticClass: "invoice-shopInfo-div"
    }, [_c('div', {
      staticClass: "invoice-table-div"
    }, [_c('span', {
      staticClass: "invoice-table-time"
    }, [_vm._v("申请时间：" + _vm._s(da.createTime) + " ")]), _vm._v(" "), _c('span', {
      staticClass: "invoice-table-No"
    }, [_vm._v("订单编号：" + _vm._s(da.orderNo))])]), _vm._v(" "), _c('table', {
      directives: [{
        name: "loading",
        rawName: "v-loading.fullscreen.lock",
        value: (_vm.fullscreenLoading),
        expression: "fullscreenLoading",
        modifiers: {
          "fullscreen": true,
          "lock": true
        }
      }],
      staticClass: "invoice-table"
    }, _vm._l((da.orderDetails), function(data, i) {
      return _c('tr', {
        key: i,
        staticClass: "invoice-table-tr"
      }, [_c('td', {
        staticStyle: {
          "border": "1px solid #EEEEEE"
        },
        attrs: {
          "width": " 620px"
        }
      }, [_c('img', {
        staticClass: "invoice-table-img",
        attrs: {
          "src": data.itemImgUrl
        },
        on: {
          "click": function($event) {
            return _vm.openGoodsDetails(data.serviceItemId)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "invoice-table-td-font",
        on: {
          "click": function($event) {
            return _vm.openGoodsDetails(data.serviceItemId)
          }
        }
      }, [_vm._v(_vm._s(data.supplierName))]), _vm._v(" "), _c('span', {
        staticClass: "invoice-table-td-dj"
      }, [_vm._v("￥" + _vm._s(data.unitPrice))]), _vm._v(" "), _c('span', {
        staticClass: "invoice-table-td-num"
      }, [_vm._v(_vm._s(data.quantity) + " 份")])]), _vm._v(" "), _c('td', {
        staticStyle: {
          "border": "1px solid #EEEEEE",
          "text-align": "center"
        },
        attrs: {
          "width": " 150px"
        }
      }, [_c('span', {
        staticClass: "invoice-table-td-money"
      }, [_vm._v("￥" + _vm._s(data.amount))]), _vm._v(" "), _c('span', {
        staticClass: "invoice-table-td-type"
      }, [_vm._v("共" + _vm._s(data.quantity) + "件")])])])
    }), 0)])
  })], 2)], 1), _vm._v(" "), _c('mall-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "invoice-info"
  }, [_vm._v("发票信息 ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ecc24f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/InvoiceDetails.vue
// module id = 325
// module chunks = 2